import React, { useContext } from 'react';
import { Checkbox, FormControlLabel, FormGroup, Box } from '@mui/material';

import { EventsFilterContext, EventsFilterDispatchContext } from 'context/eventsFilter';

import { DetectionTypes } from 'types/aspen/activity';

import { IconPerson, IconPackage, IconVehicle, IconPet, IconMotion, IconSound } from 'components/icons';

import styles from './eventTypesFilter.module.scss';

const EVENT_TYPE_MAP: Array<{
  type: DetectionTypes;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}> = [
  { type: 'person', label: 'Person', icon: IconPerson },
  { type: 'package', label: 'Package', icon: IconPackage },
  { type: 'vehicle', label: 'Vehicle', icon: IconVehicle },
  { type: 'pet', label: 'Pet', icon: IconPet },
  { type: 'motion', label: 'Motion', icon: IconMotion },
  { type: 'sound', label: 'Sound', icon: IconSound },
];

export const EventTypesFilter = () => {
  const { filterState } = useContext(EventsFilterContext);
  const dispatch = useContext(EventsFilterDispatchContext);

  const handleEventTypeChange = (eventType: DetectionTypes, checked: boolean): void => {
    const newObjectsDetected = checked
      ? [...filterState.objectsDetected, eventType]
      : filterState.objectsDetected.filter((type) => type !== eventType);

    dispatch({
      type: 'filterState',
      payload: { objectsDetected: newObjectsDetected },
    });
  };

  return (
    <Box className={styles.container}>
      <FormGroup className={styles.formGroup}>
        {EVENT_TYPE_MAP.map(({ type, label, icon: Icon }) => (
          <FormControlLabel
            key={type}
            control={
              <Checkbox
                checked={filterState.objectsDetected.includes(type)}
                onChange={(e) => handleEventTypeChange(type, e.target.checked)}
                data-testid={`checkbox-event-type-${type}`}
              />
            }
            label={
              <Box className={styles.labelContainer}>
                <Icon className={styles.icon} />
                <span>{label}</span>
              </Box>
            }
          />
        ))}
      </FormGroup>
    </Box>
  );
};
